indexHandler = {
    $smallFilterText      : $('.small-filter-text'),
    $smallFilterContainer : $('.small-filter-container'),
    $sortItemContainer    : $('.sort-item-container'),
    $sortText             : $('.sort-text'),
    $sortSelected         : $('.selected-sort'),
    $filterItem           : $('.list-item-button'),
    $filterTitle          : $('.list-item-title'),
    $resultContainer      : $('.result-container'),
    $resultText           : $('.result-text'),
    $resultCount          : $('.result-count'),
    $resultSuffix         : $('.result-suffix'),
    $filterResult         : $('.filter-result-container'),
    $indexContainer       : $('.index-container'),
    $panelContent         : $('.panel-content-index'),
    $html                 : $('html'),
    $resetFilter          : $('[href="#reset-filter"]'),
    loadTimeout : null,
    isLoad : false, 

    reinitializeMasonry: function() {
        var $masonryContainer = this.$indexContainer.find('.panel-content-index').find('.masonry-container');
        $masonryContainer.imagesLoaded( function() {
            $masonryContainer.masonry({
                itemSelector: $(this).data('masonry-item'),
                columnWidth:  $(this).data('masonry-sizer'),
                percentPosition: true,
                transitionDuration: 0,
            });
            $masonryContainer.masonry('reloadItems');
        });
    },

    indexAjax: function($param) {
        var self = this;
        self.$indexContainer.find('.panel-content-index').empty();
        self.$indexContainer.find('.panel-content-index').addClass('loading-container');

        if (self.isLoad == false) {
            $.ajax({
                type: 'post',
                url: myAjax.ajax_url,
                data: {
                    action: 'load_index_paging',
                    page_index: $param['page_index'],
                    sort_field: $param['sort_field'],
                    sort_order: $param['sort_order'],
                    filter_designer : $param['filter_designer'],
                    filter_country  : $param['filter_country'],
                    filter_keyword  : $param['filter_keyword'],
                    filter_decade 	: $param['filter_decade'],
                },
                beforeSend: function(){
                    self.isLoad = true;
                    self.$resultText.addClass('hide');
                    self.$resultCount.html('');
                    self.$resultSuffix.html('');
                },
                success: function(response) {
                    let $resultHtml = response['html'];
                    self.$indexContainer.find('.panel-content-index').replaceWith($resultHtml);
                    self.reinitializeMasonry();
                    self.isLoad = false;

                    var itemCount = self.$indexContainer.find('.panel-content-index').data('all-count');
                    
                    if (itemCount > 0) {
                        self.$resultText.removeClass('hide');
                        self.$resultCount.html(itemCount);

                        if (itemCount > 1)
                            self.$resultSuffix.html('s');
                    }
                }
            });
        }
    },

    pagingOnClick : function($obj) {
        var self = this;
        var currIndex = $('.paging-num.is-current').data('paging-num');
        var pageIndex = $($obj).data('paging-num');
        
        if ($($obj).hasClass('next-num')) {
            pageIndex = currIndex+1;
        } else if ($($obj).hasClass('back-num')) {
            pageIndex = currIndex-1;
        }

        $('html, body').animate({
            scrollTop : self.$indexContainer.position().top - 100
        }, 100);

        if (currIndex != pageIndex) {
            searchHandler.setCookieSearchParams('page_index', pageIndex);
            searchHandler.loadData();
        }
    },

    onClickItem : function($obj, isLoad = true){
        searchHandler.setCookieSearchParams('page_index', 1);
        var self = this;
        var filterId    = ($obj.attr("id")) ? $obj.attr("id") : $obj.attr("for");
        var filterValue = $obj.val();
        var filterName  = $obj.attr("name");
        var type        = $obj.data("type");
        var $filterItemTemp = $obj;
        var checked         = $obj.prop("checked");

        if (filterId.indexOf('-small') == -1) {
            var $item = $('#'+filterId+'-small');
        } else {
            var $item = $('#'+filterId.replace('-small',''));
        }

        if ($item.length > 0) {
            $item.prop('checked', true);
        }

        if (checked == true) {
            self.generateCloseItem($obj);
            
        } else if (checked == false){
            var $resultItemTemp = $('.result-item[data-id="'+filterId+'"]');
            $resultItemTemp.remove();

            if (self.$resultContainer.find('.result-item').length == 0) {
                self.$filterResult.removeClass('is-show');
                self.$filterResult.find('.result-text').attr('tabindex', '-1');
                self.$filterResult.find('.result-text').attr('aria-hidden', 'true');
                self.$filterResult.find('.reset-button').attr('tabindex', '-1');
                self.$filterResult.find('.reset-button').attr('aria-hidden', 'true');
                searchHandler.indexHtml = '';
            }
            searchHandler.setCookieSearchParams(type, filterValue, true);
        }

        if (isLoad) {
            if (self.loadTimeout) clearTimeout(self.loadTimeout);
            self.loadTimeout = setTimeout(searchHandler.loadData(false, false, true), 1000);
            //self.updateUrl();
        }
    },

    updateUrl: function(){
        var self = this;
        let url        = '';
        let arr_params = {};
        let type       = '';
        let value      = '';

        $($('.result-container')[0]).children().each(function(){
            let filterValue = $(this).data('filter-value');
            let dataId      = $(this).data('id');
            let name        = dataId.replace('-'+filterValue, '');
            
            arr_params[name] = (arr_params[name] ? arr_params[name]+',' : '')+filterValue;
        });

        $.each( arr_params, function( key, val ) {
            type  = ((type) ? type+',' : '')+key;
            value = ((value) ? value+'-' : '')+val; 
        });

        if ((value !== '') && (type !== '')) {
            url = '&type='+type+'&id='+value; 
            url = url.substring(1);
            url = window.location.origin+window.location.pathname+'?'+url;
        } else {
            url = window.location.href.replace(window.location.search, '');
        }
        window.history.pushState("Posterhouse E-Museum", "Posterhouse E-Museum", url);
    },

    generateCloseItem: function($obj){
        var self = this;
        var filterId    = ($obj.attr("id")) ? $obj.attr("id") : $obj.attr("for");
        var filterValue = $obj.val();
        var filterName  = $obj.attr("name");
        var type        = $obj.data("type");

        var $resultItemTemp = jQuery("<div data-filter-value="+filterValue+">"+filterName+"</div>")
        .attr({
            'class': 'result-item',
            'data-id': filterId,
            'tabindex': '0',
            'aria-label': 'Selected filter '+type+' '+filterName,
        });

        if (self.$resultContainer.find('.result-item').length == 0) {
            self.$filterResult.addClass('is-show');
            self.$filterResult.find('.result-text').attr('tabindex', '0');
            self.$filterResult.find('.result-text').attr('aria-hidden', 'false');
            self.$filterResult.find('.reset-button').attr('tabindex', '0');
            self.$filterResult.find('.reset-button').attr('aria-hidden', 'false');
        }

        if (self.$resultContainer.find('.result-item').length == 0 || self.$resultContainer.find('.result-item#'+filterId).length == 0) {
            $resultItemTemp.appendTo(self.$resultContainer);
            searchHandler.setCookieSearchParams(type, filterValue);
        }
    },

    getUrlParameter: function(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    },

    loadByParams: function(){
        let self          = this;
        let sPageURL      = window.location.search.substring(1);
        let sURLVariables = sPageURL.split('&');
        let id   = '';
        let type = '';
        var queryParams = new URLSearchParams(window.location.search)

        // If search-query param exists, add the cookie
        if (queryParams.has('search-query')) {
            searchHandler.setCookieSearchParams('text', queryParams.get('search-query'))
        }

        sURLVariables.forEach( (val, key) => {
            val = val.split('=')[1];
            if (key == 0) {
                type = (val+',').split(','); 
            } else {
                id   = (val+'-').split('-');

                let ids = [];
                type.forEach( (v, k) => {
                    ids = (id+',').split(',');
                    ids.forEach(currId => {
                        if (currId) {
                            var $selectedItem = $('.list-item-button#'+v+'-'+currId);
                                
                            if ($selectedItem.length > 0) {
                                self.onClickItem($selectedItem, false);
                            } 
                        }
                    });
                })
            }
        });
    },

    init: function() {
        var self = this;

        self.reinitializeMasonry();
        
        setTimeout(() => {
            $('[data-masonry]').masonry( 'layout' );
        }, 1000);
        
        $('[data-masonry]').masonry( 'on', 'layoutComplete', function() {
            $window.trigger("resize");
        });

        var itemCount = indexHandler.$indexContainer.find('.panel-content-index').data('all-count');
        if (itemCount > 0) {
            self.$resultText.removeClass('hide');
            self.$resultCount.html(itemCount);

            if (itemCount > 1)
                self.$resultSuffix.html('s');
        }

        self.$resetFilter.on('click', function(e){
            e.preventDefault();
            Cookies.set('filters', "");
            self.$filterItem.prop('checked', false);
            self.$resultContainer.html('');
            self.updateUrl();
            searchHandler.indexHtml = '';
            searchHandler.loadData();
        });

        self.$indexContainer.on('click', '.paging-num', function(e) {
            e.preventDefault();
            self.pagingOnClick(this);
        });

        self.$smallFilterText.on('click', function(e) {
            
            if (self.$html.hasClass('disable-scroll')) {
                self.$html.removeClass('disable-scroll');
                self.$html.css({
                    'padding-right' : '0px' 
                });
            } else {
                self.$html.addClass('disable-scroll');
                var $outer = $('<div>').css({visibility: 'hidden', width: 100, overflow: 'scroll'}).appendTo('body'),
                    widthWithScroll = $('<div>').css({width: '100%'}).appendTo($outer).outerWidth();
                $outer.remove();
    
                var ScrollWidth = 100 - widthWithScroll;
                self.$html.css({
                    'padding-right' : '-'+ScrollWidth+'px' 
                });
            }

            if (Foundation.MediaQuery.only('small')) {
                if (self.$sortText.hasClass('is-active')) {
                    self.$sortText.click();
                }
            }

            if ($(this).hasClass('is-active')) {
                $(this).removeClass('is-active');
                self.$smallFilterContainer.find('.accordion .filter-container').slideUp();
                self.$smallFilterContainer.find('.accordion .panel-filter-index').removeClass('is-active');
            } else {
                $(this).addClass('is-active');
            }

            if (self.$smallFilterContainer.hasClass('is-show')) {
                self.$smallFilterContainer.removeClass('is-show');
            } else {
                self.$smallFilterContainer.addClass('is-show');
            }
        });

        self.$sortText.on('click', function(e) {
            e.preventDefault();

            if (Foundation.MediaQuery.only('small')) {
                if (self.$smallFilterText.hasClass('is-active')) {
                    self.$smallFilterText.click();
                }
            }

            if ($(this).hasClass('is-active')) {
                $(this).removeClass('is-active');
            } else {
                $(this).addClass('is-active');
            }

            if (self.$sortItemContainer.hasClass('is-show')) {
                self.$sortItemContainer.removeClass('is-show');
            } else {
                self.$sortItemContainer.addClass('is-show');
            }
        });

        self.$sortItemContainer.find('.sort-item').on('click', function(e) {
            e.preventDefault();
            var sortField = $(this).data('sort-field');
            var sortOrder = $(this).data('sort-order');
            var sortName  = $(this).text();
            var selSortField  = self.$sortSelected.data('sort-field');
            var selOrderField = self.$sortSelected.data('sort-order');
            self.$sortItemContainer.removeClass('is-show');
            self.$sortText.removeClass('is-active');

            tmp = Cookies.get('filters');
            
            if (sortField != selSortField) {
                self.$sortSelected.data('sort-field', sortField);
                self.$sortSelected.data('sort-order', sortOrder);
                self.$sortSelected.text(sortName);
            
                searchHandler.setCookieSearchParams('sort_field', selSortField, true);
                searchHandler.setCookieSearchParams('sort_order', selOrderField, true);
                searchHandler.setCookieSearchParams('sort_field', sortField);
                searchHandler.setCookieSearchParams('sort_order', sortOrder);
                searchHandler.loadData();
            }
        });

        self.$filterItem.on('click', function() {
            self.onClickItem($(this), true);
        });

        $(document).on('click', '.result-item', function(){
            var filterVal    = $(this).data('filter-value');
            var $objListItem = $('.list-item-button[value="'+filterVal+'"]');
            var $objItem     = $('.result-item[data-filter-value="'+filterVal+'"]');
            var type         = $objListItem.data('type');
            
            $objItem.remove();
            $objListItem.prop("checked", false);

            if (self.$resultContainer.find('.result-item').length == 0) { 
                self.$filterResult.removeClass('is-show');
                self.$filterResult.find('.result-text').attr('tabindex', '-1');
                self.$filterResult.find('.result-text').attr('aria-hidden', 'true');
                self.$filterResult.find('.reset-button').attr('tabindex', '-1');
                self.$filterResult.find('.reset-button').attr('aria-hidden', 'true');
                searchHandler.indexHtml = '';
            }
        
            searchHandler.setCookieSearchParams(type, ''+filterVal+'' , true);
            self.updateUrl();
            searchHandler.loadData();
        });

        self.loadByParams();

        $('.filter-form').on('submit', function(e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 'slow');
            searchHandler.loadData();
            self.updateUrl();
        });
    }
}